module.exports = __webpack_public_path__ + "img/card-review-02.2f030079.png";